import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ERegionPostcodesComponent } from '../../components/manage-eregion-postcodes/manage-eregion-postcodes.component';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { PostcodeMapsModule } from './postcode-maps.module';

const routes: Routes = [
  {
    path: '',
    component: ERegionPostcodesComponent,
    data: { title: 'Manage Engineius Region Postcodes' },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ERegionPostCodesRoutingModule {}

@NgModule({
  imports: [
    ERegionPostCodesRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
    PostcodeMapsModule,
  ],
  declarations: [ERegionPostcodesComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ERegionPostCodesModule {}
